<script setup>
import { computed } from 'vue';
import { vOnClickOutside } from '@vueuse/components';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click', 'close']);

const isTokenValid = computed(() => {
  return window.chatwootConfig?.campaignsTokenValid === true;
});

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-surface-1">
    <div v-if="!isTokenValid" class="flex items-center justify-center h-full p-8">
      <div class="text-center bg-white p-8 rounded-lg shadow-sm max-w-lg mx-auto">
        <h2 class="text-xl font-semibold text-slate-800 mb-4">Funcionalidad no activa</h2>
        <p class="text-slate-600">La funcionalidad no está activa, por favor contacte a su administrador.</p>
      </div>
    </div>
    <template v-else>
      <header class="sticky top-0 z-10 px-6">
        <div class="w-full max-w-5xl mx-auto">
          <div class="flex items-center justify-between w-full h-20 gap-2">
            <span class="text-heading-1 text-n-slate-12">
              {{ headerTitle }}
            </span>
            <div
              v-on-click-outside="[
                () => emit('close'),
                // This will prevent closing the modal when the editor Create link popup is open
                { ignore: ['dialog.ProseMirror-prompt-backdrop'] },
              ]"
              class="relative group/campaign-button"
            >
              <Button
                :label="buttonLabel"
                icon="i-lucide-plus"
                size="sm"
                class="group-hover/campaign-button:brightness-110"
                @click="handleButtonClick"
              />
              <slot name="action" />
            </div>
          </div>
        </div>
      </header>
      <main class="flex-1 px-6 overflow-y-auto">
        <div class="w-full max-w-5xl mx-auto py-4">
          <slot name="default" />
        </div>
      </main>
    </template>
  </section>
</template>
